<template>
	<div class="container grid grid-cols-1 lg:grid-cols-2 gap-8">
		<!-- Finding a Schedule -->
		<FindingSchedule
			ref="schedules"
			@findResults="getResults"
		></FindingSchedule>

		<!-- Results -->
		<Results
			v-if="results"
			ref="results"
			:results="results"
			@findResults="getJourney"
		></Results>

		<!-- Journey -->
		<Journey v-if="journey" :journey="journey" ref="journey"></Journey>
	</div>
</template>

<script>
import axios from "axios";
import FindingSchedule from "./FindingSchedule.vue";
import Results from "./Results.vue";
import Journey from "./Journey.vue";

/**
        title: Schedule Form
        data: {}
        components: {
            - FindingSchedule: Fields to Find a Schedule Based on Departure, Arrival and Date
            - Results: The results from the Find Schedule form
            - Journey - The Journey chosen from the Results
        }
        methods: {
			- getResults: Get the results from the FindingSchedule component and pass them through to the results data. We also want to remove any journey data when this is updated.
			- getJourney: Get the results from the Results component & pass them to the voyage endpoint. We then want to pass the response to the journey data so it can be used by the Journey Component.
		}
    **/
export default {
	data: function () {
		return {
			results: null,
			journey: null,
		};
	},
	components: {
		FindingSchedule,
		Results,
		Journey,
	},
	methods: {
		getResults: function (data) {
			if (data.error) {
				this.results = null;
			} else {
				this.results = data;
			}
			this.journey = null;
		},
		getJourney: function (data) {
			// Create a new formData object
			let journeyData = new FormData();

			// Add the Craft CSRF Token to the FormData - This is required by the PHP Model
			journeyData.append("CRAFT_CSRF_TOKEN", window.csrfToken);

			journeyData.append("vessel", data.vessel);
			journeyData.append("fromPort", data.fromPort);
			journeyData.append("toPort", data.toPort);
			journeyData.append("departureDate", data.departureDate);
			journeyData.append("arrivalDate", data.arrivalDate);
			journeyData.append("voyageNumbers", data.voyageNumbers);
			journeyData.append("duration", data.duration);

			// Send the Form Data
			axios
				.post("/actions/predator/schedule/voyage", journeyData)
				.then((response) => {
					if (response.data.error) {
						// If an error exists, we want to throw the data to the catch
						throw { response: response.data };
						forms();
					} else {
						// Push the Schedule Results back to the parent
						this.journey = response.data;
					}
				})
				.catch((error) => {});
		},
	},
};
</script>
